import {Origine,Visibilite} from "@domain/geolocalisation/localisation";
import {LegacyFloatLabelType as FloatLabelType} from "@angular/material/legacy-form-field";

/**
 * Paramétrage pour utiliser le component lieu
 */
export class LieuParam {
    /** Obligatoire, url utilisée pour faire la recherche des adresses */
    urlAdresse: string;

    /** Obligatoire, indique si on peut saisir une adresse manuellement */
    isSaisieAutorisee: () => boolean;

    /** Obligatoire, valeur du placeholder de l'input */
    placeHolder: (libelleAdresse: String,isDisabled: boolean) => string;

    /** Visibilité pour la localisation v_NF par défaut */
    listeVisibiliteLocalisation: Visibilite[] = [Visibilite.FILTRE_V_NF];

    /** Origine pour la localisation */
    origineLocalisation: Origine = Origine.ORIGINE_USER;

    /** Id de l'utilisateur */
    idUser: number = undefined;

    /** Permet de revenir sur l'onglet "saisie d'adresse" */
    isRevenirOngletSaisieAdresseAfterSelect = false;

    /** Dans le cas d'une adresse incomplete, on passe à l'onglet de saisie pour la compléter */
    isOngletSaisieWithAdresseIncomplete = false;

    /** Indicateur d'affichage de la liste simple des adresses et des établissements */
    isShowAdresseBaseAndEtablissement: boolean = false;

    /** Permet de définir le libellé à afficher de l'input au chargement du modèle */
    libelleInputFormatOnInit: (data: any) => string;

    /** Permet de définir le libellé à afficher de l'input à la sélection du modèle */
    libelleInputFormatOnSelect: (data: any) => string;

    /** Type du float label à afficher (never par défaut) */
    floatLabel: FloatLabelType = "never";

    /**
     * Permet de convertir la donnée source (adresse/localisation) en donnée attendue par le back
     * Utilise le mapping historique de composant si null
     */
    mapper: (data: any) => any;

    /* Paramètres de l'onglet adresse avec les filtres */

    /** Indicateur d'affichage de la liste filtre */
    isShowAdresseFiltre: boolean = false;

    /** Obligatoire, titre de la liste */
    titleAdresseTab: string;

    /** Indicateur de visiblité adresse pro/perso */
    isShowProPersoAdresseFiltre: boolean = false;

    /** Indicateur du type d'adresse renvoyé si c'est une localisation */
    isFormatRueFromString: boolean = false;
    isFormatRueFromLocalisation: boolean = false;

    /** Indicateur d'affichage des adresses admin et utilisateur */
    isShowAdminAndUserAdresse: boolean = false;

    /* Paramètres de l'onglet lieux récents */

    /** Indicateur d'affichage de l'onglet "Lieux récents" */
    isShowLieuxRecents: boolean = false;

    /** URL utilisée pour charger les lieux récents */
    urlLieuxRecents: string;

    /* Paramètre pour la saisie d'une adresse */

    /** Affiche le bouton valider (permet la saisie sans géolocalisation) */
    isBoutonValider: boolean = true;

    /** Permet de géolocaliser des lieux avec rue uniquement */
    isGeolocaliserWithoutRue: boolean = false;

    /** Permet d'ouvrir l'outil de géolocalisation si le lieu sélectionné n'est pas géolocalisé */
    isGeolocaliserOnSelect: boolean = false;

    /** Indique si un toast de warning doit être affiché dans le cas d'une validation sans géolocalisation */
    isValiderWarningWithoutGeolocalisation: boolean = true;

    /** Indique si la rue est obligatoire */
    isRueRequired: boolean = false;
}